import React, { FC, SVGProps, useEffect } from "react";
import "../../../../assets/css/page/CommonModal.scss";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Button,
} from "@mui/material";
import { ReactComponent as CrossIcon } from "../../../../assets/Images/CrossIcon.svg";
import { buttonStyles } from "../../../../assets/MUIStyles/popupStyles";
import { LoadingSlides } from "../Common";
import { commonStyles } from "../../../../assets/MUIStyles/commonStyles";

interface CommonIconProp {
  message: string;
  show: boolean;
  toggle: () => void;
  heading: string;
  Icon: FC<SVGProps<SVGSVGElement>>;
  spin?: boolean;
  headerText?: string;
}

const CommonPopup = ({
  headerText = "Success",
  message,
  show,
  toggle,
  spin = false,
  heading = "",
  Icon,
}: CommonIconProp) => {
  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (show) {
      timer = setTimeout(() => {
        toggle();
      }, 3000);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [show, toggle]);

  return (
    <Dialog
      open={show}
      onClose={toggle}
      scroll="body"
      classes={{ paper: "common-modal-450" }}
      slotProps={{
        paper: {
          sx: {
            borderRadius: "12px",
            maxWidth: 450,
            width: "100%",
          },
        },
      }}
    >
      <DialogTitle
        className="new-modal-header popup-header"
        sx={commonStyles.popUpcontainer}
      >
        <span className="font-14-600-grey">{headerText}</span>
        <IconButton onClick={toggle} className="modal-cross-icon" size="small">
          <CrossIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        className="new-modal-body"
        sx={{ padding: "1rem 2rem !important" }}
      >
        <Box className="flex-column" sx={{ justifyContent: "center" }}>
          <Box
            className="flex-column-center"
            sx={{
              width: "270px",
              mx: "auto",
            }}
          >
            <Box
              className="flex-xy-center"
              sx={{
                width: 150,
                height: 150,
              }}
            >
              <Icon />
            </Box>

            <Typography
              className="font-18-600-grey"
              sx={{ mt: 2, textAlign: "center" }}
            >
              {heading}
            </Typography>
          </Box>

          <Typography
            className="font-14-lightgrey"
            sx={{ mt: 1, textAlign: "center" }}
          >
            {message}
          </Typography>
        </Box>

        <Box className="flex-between" sx={{ my: 3, px: 1.5, gap: 2 }}>
          <Button sx={buttonStyles.cancel} onClick={toggle}>
            Close
          </Button>
          <Button
            className="flex-xy-center"
            variant="contained"
            onClick={toggle}
            sx={{ width: "193px", height: "40px" }}
          >
            {spin ? <LoadingSlides bgColor="white" /> : "Okay, thanks"}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CommonPopup;
